const columns = [
    
    {
      title: "Score",
      field: "TotalScore",
      locked: false,
      filter: "numeric",
      width: 150,
      className:"text-end",
      show: true,
    },
    {
      title: "Serv Pts",
      field: "ServPt",
      locked: false,
      filter: "numeric",
      width: 170,
      show: true,
      className:"text-end",
    },
    {
      title: "Perf Pts",
      field: "PerformancePoint",
      locked: false,
      filter: "numeric",
      width: 150,
      show: true,
      className:"text-end",
    },
    {
      title: "A. Date",
      field: "APPLICATION_DATE",
      locked: false,
      filter: "date",
      format: "MM/DD/YYYY",
      editor: "date",
      width: 170,
      show: true,
    },
    {
      title: "Name",
      field: "EmployeeName",
      locked: false,
      filter: "text",
      width: 190,
      show: true,
    },
    {
      title: "Pos. Title",
      field: "PositionTitle",
      locked: false,
      filter: "text",
      width: 190,
      show: true,
    },
    {
      title: "Section",
      field: "DepartmentDivisionName",
      locked: false,
      filter: "text",
      width: 280,
      show: true,
    },
    {
      title: "Grade/Step",
      field: "GradenStep",
      locked: false,
      filter: "text",
      width: 160,
      show: true,
    },
    {
      title: "Salary",
      field: "Salary",
      locked: false,
      filter: "numeric",
      width: 160,
      show: true,
      className: "text-end",
      headerClassName: "number-align",
    },
    {
      title: "Emp Id",
      field: "EmpNo",
      locked: false,
      filter: "numeric",
      width: 160,
      show: true,
      // filter: "numeric",
      customFilterType: "CustomNumericText",
      className: "text-end",
      headerClassName: "number-align",
    },
    {
      title: "CSC Classcode",
      field: "CSC_Code",
      locked: false,
      filter: "text",
      width: 165,
      show: true,
    },
  ];
  
  export default columns;
  